import { CmsApiTwoTilesBlockData } from 'modules/cms/api/types/CmsApiTwoTiles';
import { CmsAmpSplitContentBlock } from 'modules/cms/blocks/Amp/CmsAmpSplitContentBlock';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpTwoTilesBlock({
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiTwoTilesBlockData>) {
  const buttonOne =
    data.tileOneButtonText && data.tileOneButtonUrl
      ? {
          text: data.tileOneButtonText,
          data: {
            ur: data.tileOneButtonUrl,
          },
        }
      : null;

  const buttonTwo =
    data.tileTwoButtonText && data.tileTwoButtonUrl
      ? {
          text: data.tileTwoButtonText,
          data: {
            ur: data.tileTwoButtonUrl,
          },
        }
      : null;

  return (
    <CmsAmpSplitContentBlock
      data={{
        sections: [
          {
            type: 'TEXT',
            data: {
              headline: data.tileOneHeadline,
              html: data.tileOneText,
              // @ts-expect-error Fix me
              button: buttonOne,
            },
          },
          {
            type: 'TEXT',
            data: {
              headline: data.tileOneHeadline,
              html: data.tileOneText,
              // @ts-expect-error Fix me
              button: buttonTwo,
            },
          },
        ],
      }}
    />
  );
}
